import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class RouteRenderContextManager {
  constructor() {
    _defineProperty(this, "routeRenderContexts", new Set());
  }
  registerRouteRenderContext(rrc) {
    this.routeRenderContexts.add(rrc);
  }
  unregisterRouteRenderContext(rrc) {
    this.routeRenderContexts.delete(rrc);
  }

  /** @returns true iff there are any dirty routes */
  hasUnsavedChanges() {
    for (const rrc of this.routeRenderContexts) {
      if (rrc.currentRouteHandler?.hasUnsavedChanges()) return true;
    }
    return false;
  }

  /** @returns all RouteRenederContext instances that hold dirty routes (rrc.currentRouteHandler?.hasUnsavedChanges()) */
  getDirtyRouteRenderContexts() {
    const retList = [];
    this.routeRenderContexts.forEach(rrc => {
      if (rrc.currentRouteHandler?.hasUnsavedChanges()) {
        retList.push(rrc);
      }
    });
    return retList;
  }
  destroy() {
    this.routeRenderContexts.clear();
  }
}
//# sourceMappingURL=RouteRenderContextManager.js.map
